/**
 * @param {number} value
 * @returns {number}
 */
export function roundByDPR(value) {
  const dpr = window.devicePixelRatio ?? 1;
  return Math.round(value * dpr) / dpr;
}